import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';

interface IProps {
  talkTime: string;
  interactiveTotal: string;
  callType: string;
}

/**
 * Fills the region the capacity readout and tile row vacate when the contact
 * ENDS — ~136px that would otherwise be dead whitespace inside a panel pinned at
 * 402px. Vocabulary matches the interactive-time strip the agent already reads
 * elsewhere, so it is not a new concept.
 *
 * This is the panel's flex:1 child in the ended state; do not give it a fixed
 * height.
 */
const CallSummary: FC<IProps> = ({ talkTime, interactiveTotal, callType }) => {
  const { t } = useTranslation();

  const rows = [
    {
      label: t('connectPanel.summary.talkTime'),
      value: talkTime,
      numeric: true,
    },
    {
      label: t('connectPanel.summary.interactiveTotal'),
      value: interactiveTotal,
      numeric: true,
    },
    {
      label: t('connectPanel.summary.callType'),
      value: callType,
      numeric: false,
    },
  ];

  return (
    <div className={s.summary} data-cy="call-summary">
      <span className={s['summary-title']}>{t('connectPanel.wrapUp')}</span>
      <span className={s['summary-note']}>{t('connectPanel.wrapUpNote')}</span>

      <div className={s['summary-rows']}>
        {rows.map(({ label, value, numeric }) => (
          <div key={label} className={s['summary-row']}>
            <span className={s['summary-label']}>{label}</span>
            <span
              className={numeric ? s['summary-value-num'] : s['summary-value']}
            >
              {value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CallSummary;
